import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { AuthContext, AuthContextValue } from './AuthContext'
import { AuthState, AuthUser, clearSession, getSession, setSession } from '../lib/session'

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [token, setToken] = useState<string | null>(null)
	const [user, setUser] = useState<AuthUser | null>(null)
	const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {
		const session = getSession()
		if (session) {
			setToken(session.token)
			setUser(session.user)
		}
		setIsLoading(false)
	}, [])

	const setAuth = useCallback((auth: AuthState) => {
		setToken(auth.token)
		setUser(auth.user)
		setSession(auth)
	}, [])

	const logout = useCallback(() => {
		setToken(null)
		setUser(null)
		clearSession()
	}, [])

	const value = useMemo<AuthContextValue>(
		() => ({ token, user, setAuth, logout, isLoading }),
		[token, user, setAuth, logout, isLoading],
	)

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
